import { render, staticRenderFns } from "./InternalService.vue?vue&type=template&id=68c00bc1&scoped=true"
import script from "./InternalService.vue?vue&type=script&lang=js"
export * from "./InternalService.vue?vue&type=script&lang=js"
import style0 from "./InternalService.vue?vue&type=style&index=0&id=68c00bc1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c00bc1",
  null
  
)

export default component.exports